// extracted by mini-css-extract-plugin
export default {"header":"keys_header__dNba9","search":"keys_search__OC7lI","pagination":"keys_pagination__OUgAj","actions":"keys_actions__Ej9Pe","spin":"keys_spin__3hSBx"};